<template>
  <div class="select-service">
    <van-radio-group v-model="radio" disabled>
      <van-radio name="1" label-position="right">
        <div class="titleBig">车站举牌（敬请期待）</div>
        <div class="titlesmall">专人等候，接站引导上车</div>
      </van-radio>
      <div class="xian"></div>
      <van-radio name="2">
        <div class="titleBig">预约停车场（敬请期待）</div>
        <div class="titlesmall">专用停车场等候接驳</div>
      </van-radio>
      <div class="xian"></div>
      <van-radio name="3">
        <div class="titleBig">咨询服务（敬请期待）</div>
        <div class="titlesmall">提供站台免费咨询服务</div>
      </van-radio>
      <div class="xian"></div>
    </van-radio-group>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  getNowData,
  __getItem,
  __setItem,
} from "@/utils/index";
import { RadioGroup, Radio } from 'vant';
Vue.use(RadioGroup).use(Radio);


export default {
  name: 'select-service',
  data: () => ({
    radio: 0
  }),
}
</script>
<style>
  .select-service .van-radio {
    padding-bottom: 5px;
  }
  .select-service .van-radio__label {
    display: block!important;
  }
  .select-service .van-radio {
    position: relative;
  }
  .xian {
    width: 80%;
    height: 1px;
    margin: 0 auto;
    background-color: #e5e5e5;
  }
  /* .select-service .van-radio:after {
    content: "";
    width: 80%;
    height: 0.02667rem;
    background-color: #e5e5e5;
    position: absolute;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
  } */
  .select-service .titleBig {
    height:16px;
    font-size:16px;
    font-family:PingFang-SC-Bold,PingFang-SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    margin-left: 60px;
    margin-top: 10px;
    text-align: left;
  }
  .select-service .titlesmall {
    font-size:13px;
    font-family:PingFang-SC-Medium,PingFang-SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    margin-left: 60px;
    margin-top: 10px;
    text-align: left;
  }
  .select-service .van-radio__icon {
    position: absolute;
    left: 30px;
    right: 0;
    top: 40%;
  }
</style>
<style lang="scss" scoped>
  
  .select-service {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    padding-bottom: 45px;
    z-index: 5555;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 4px 0px rgba(0,0,0,0.1);
    border-radius:10px 10px 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/components/selectService.vue